import { useAuthState } from "../../OS/Login/State";
import { useEffect } from "react";

import { config } from "../../config";

import { StoresprintTracking } from "./mixpanel";
import * as Sentry from "@sentry/react-native";

import { addBreadcrumb } from "../sentry";

const tracking = new StoresprintTracking(config.mixpanelToken);

let currentScreen: string | undefined;

export const registerLogin = async () => {
  if (!config.production) {
  }
};

export const registerScreen = (
  screenPath: string,
  params?: object,
  alwaysRegister = false
) => {
  if (
    screenPath !== currentScreen ||
    alwaysRegister ||
    screenPath.includes("Dashboard")
  ) {
    addBreadcrumb({
      type: "navigation",
      category: "navigation",
      data: {
        from: currentScreen,
        to: screenPath,
      },
    });

    tracking.pageView(screenPath, params);
    currentScreen = screenPath;
    if (!config.production) {
    }
  }
};

let currentUserId: string;

const registerUser = async (
  userId: string,
  scope:
    | {
        id: string;
        type: "store";
      }
    | {
        id: string;
        type: "org";
      },
  isStoresprintUser?: boolean
) => {
  if (!config.production) {
    return;
  }
  if (currentUserId !== userId) {
    currentUserId = userId;
  }
  tracking.identify(userId, scope, isStoresprintUser);

  if (scope.type === "store") {
    Sentry.setTag("storeId", scope.id);
  } else {
    Sentry.setTag("orgId", scope.id);
  }

  Sentry.setTag("userId", userId);
};

export const useRegisterUser = (
  scope:
    | {
        id: string;
        type: "store";
      }
    | {
        id: string;
        type: "org";
      }
    | null
) => {
  const [authState] = useAuthState();

  useEffect(() => {
    if (!scope) {
      return;
    }
    if (authState.currentAuthSessionIndex !== undefined) {
      const user = authState.authSessions[authState.currentAuthSessionIndex];

      const isStoresprintUser =
        user?.user?.email?.endsWith("@storesprint.app") ?? false;
      registerUser(user.user.sub, scope, isStoresprintUser)
        .then(() => {})
        .catch(() => {});
    }
  }, [authState, scope]);
};
